export default {"src":"/_next/static/media/crossLocationRecovery.3f17dae3.svg","height":34,"width":31};